import { render, staticRenderFns } from "./periodo-navegavel.vue?vue&type=template&id=03b5acb8&scoped=true"
import script from "./periodo-navegavel.vue?vue&type=script&lang=ts"
export * from "./periodo-navegavel.vue?vue&type=script&lang=ts"
import style0 from "./periodo-navegavel.vue?vue&type=style&index=0&id=03b5acb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5acb8",
  null
  
)

export default component.exports